import { PricingStatusStatus, useStatus } from "@/models/backend";

export const useTrovePlan = () => {
  const { data: pricingStatus } = useStatus();
  return (
    pricingStatus || {
      status: PricingStatusStatus.OK,
      features: [],
      main_account: null,
      trial_end: null,
    }
  );
};
